export default "__VITE_ASSET__NnNJ12MP__"